<script>
import moment from 'moment'
import numeral from 'numeral'
import elementUiStyles from '@/assets/scss/modules/element-ui.module.scss'
import utilStyles from '@/assets/scss/modules/utilities.module.scss'
import { WarehouseService } from '@/services'
import { toThaiDatetime } from '@/utils/datetime'

export default {
  data() {
    const { query } = this.$route

    return {
      items: [],
      pagination: {
        page: parseInt(query.page) || 1,
        total: 0,
        pageSize: 10
      },
      isLoading: false
    }
  },

  created() {
    this.fetch()
  },

  methods: {
    async fetch() {
      const {
        params: { id },
        query
      } = this.$route

      try {
        this.isLoading = true

        const {
          data: { result }
        } = await WarehouseService.buy.transaction.getAll(id, {
          datetime_after: query.start
            ? moment(query.start).format()
            : undefined,
          datetime_before: query.end ? moment(query.end).format() : undefined,
          page: query.page
        })

        this.items = result.results.map(item => ({
          id: item.id,
          date: new Date(item.datetime),
          type: item.action_type_name,
          amount: item.amount,
          left: item.remaining_amount,
          ref: item.ref_content_type
            ? {
                type: item.action_type,
                id: item.ref_id
              }
            : null
        }))

        this.pagination = { ...this.pagination, total: result.count }
      } catch (err) {
        this.$notify.error(err.message)
      } finally {
        this.isLoading = false
      }
    },

    reset() {
      this.pagination.page = 1
    }
  },

  render() {
    const DetailButton = ({ props }) => {
      const handleClick = () => {
        switch (props.type) {
          case 'sell':
            this.$router.push({
              name: 'SellDetail',
              params: { id: props.dataId }
            })
            break

          case 'buy':
            this.$router.push({
              name: 'BuyDetail',
              params: { id: props.dataId }
            })
            break

          case 'trade':
            this.$router.push({
              name: 'TradeDetail',
              params: { type: 'old', id: props.dataId }
            })
            break

          case 'transfer_in':
            this.$router.push({
              name: 'GoldTransferReceiveDetail',
              params: { type: 'old', id: props.dataId }
            })
            break

          case 'transfer_out':
            this.$router.push({
              name: 'GoldTransferTransferDetail',
              params: { type: 'old', id: props.dataId }
            })
            break

          case 'pawn':
          case 'pawn_redeem':
          case 'dispose':
            this.$router.push({
              name: 'PawnDetail',
              params: { id: props.dataId }
            })
            break
        }
      }

      return (
        <el-button size="medium" onClick={handleClick}>
          See Detail <i class="el-icon-arrow-right"></i>
        </el-button>
      )
    }

    return (
      <el-card
        element-loading-background="rgba(0, 0, 0, 0.75)"
        element-loading-custom-class={elementUiStyles.loadingMask}
        {...{ directives: [{ name: 'loading', value: this.isLoading }] }}
      >
        <el-table
          data={this.items}
          headerCellClassName={elementUiStyles.tableCell}
          cellClassName={elementUiStyles.tableCell}
        >
          <el-table-column
            label="วันที่"
            minWidth="150"
            scopedSlots={{ default: ({ row }) => toThaiDatetime(row.date) }}
          />
          <el-table-column
            label="กิจกรรม"
            minWidth="100"
            scopedSlots={{ default: ({ row }) => row.type }}
          />
          <el-table-column
            label="เพิ่ม"
            align="right"
            minWidth="70"
            scopedSlots={{
              default: ({ row }) =>
                row.amount > 0 ? (
                  <span
                    class={utilStyles.colorSuccess}
                    style={{ fontWeight: 'bold' }}
                  >
                    {numeral(row.amount).format('0,0.00')}
                  </span>
                ) : (
                  undefined
                )
            }}
          />
          <el-table-column
            label="ลด"
            align="right"
            minWidth="70"
            scopedSlots={{
              default: ({ row }) =>
                row.amount < 0 ? (
                  <span
                    class={utilStyles.colorDanger}
                    style={{ fontWeight: 'bold' }}
                  >
                    {numeral(row.amount).format('0,0.00')}
                  </span>
                ) : (
                  undefined
                )
            }}
          />
          <el-table-column
            label="คงเหลือ (กรัม)"
            align="right"
            minWidth="70"
            scopedSlots={{
              default: ({ row }) => (
                <span style={{ fontWeight: 'bold' }}>
                  {numeral(row.left).format('0,0.00')}
                </span>
              )
            }}
          />
          <el-table-column
            width="150"
            scopedSlots={{
              default: ({ row }) =>
                row.ref &&
                row.ref.type && (
                  <DetailButton dataId={row.ref.id} type={row.ref.type} />
                )
            }}
          />
        </el-table>
        <div
          style={{
            display: 'flex',
            marginTop: '1rem',
            overflow: 'auto hidden'
          }}
        >
          <el-pagination
            background
            currentPage={this.pagination.page}
            total={this.pagination.total}
            pageSize={this.pagination.pageSize}
            layout="prev, pager, next, jumper"
            style={{ margin: 'auto' }}
            on={{
              'update:currentPage': value => {
                this.pagination.page = value
              },
              'current-change': async value => {
                await this.$router.replace({
                  query: { ...this.$route.query, page: value }
                })

                this.fetch()
              }
            }}
          />
        </div>
      </el-card>
    )
  }
}
</script>
